import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { PENDING, IDLE, EDIT } from "const"
import {
    QidProductDocument,
    MtDriveFile,
} from "server/models"
import { deepCopy, hasAccess, StateType } from "client/utils"
import {
    PRM_QID_PRODUCT,
    StoreType,
    QidProductDocumentList,
    LoadAllQidProductDocuments,
    AddQidProductDocument,
    MoveDriveFile,
    DeleteQidProductDocument,
    setQidProductDocumentList,
    setQidProductDocumentReloadList,
    addModal,
} from "client/store"
import {
    Container,
    PageContent,
    Loader,
    Button,
    Table,
    DeleteRow,
} from "client/components"

import Drive from "client/pages/drive"
import Columns from "./columns"

const Documents = () => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const productFolderId = useSelector((state: StoreType) => state.qidProduct.productFolderId)

    const documentList = useSelector((state: StoreType) => state.qidProductDocument.documentList)
    const documentIds = useSelector((state: StoreType) => state.qidProductDocument.documentIds)
    const reloadList = useSelector((state: StoreType) => state.qidProductDocument.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        if (!product || !product.id) return

        setLoadState(PENDING)
        LoadAllQidProductDocuments(product.id)
        .then((res) => {
            dispatch(setQidProductDocumentList(res.documentList, res.documentIds))
            setLoadState(IDLE)
        })
    }, [product, reloadList])

    const onDelete: DeleteRow = (document: QidProductDocument, callback) => {
        DeleteQidProductDocument(document.productId, document.fileId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const documentListCopy: QidProductDocumentList = documentList ? deepCopy(documentList) : {}
                delete documentListCopy[document.fileId]
                const newDocumentIds = documentIds.filter((id) => id !== document.fileId)

                dispatch(setQidProductDocumentList(documentListCopy, newDocumentIds))
            })
        })
    }

    const onAdd = (file: MtDriveFile) => {
        setLoadState(PENDING)
        AddQidProductDocument(product.id, file.id).then(() => {
            // move selected document to product folder
            const moveFile: MtDriveFile = {
                ...file,
                folderId: productFolderId,
            }
            MoveDriveFile(moveFile).then(() => {
                dispatch(setQidProductDocumentReloadList(false))
                setTimeout(() => {
                    dispatch(setQidProductDocumentReloadList(true))
                }, 0)
            })
        })
    }

    const productEditAccess = hasAccess(PRM_QID_PRODUCT, EDIT)
    const columns = Columns(productEditAccess)

    return (
        <Container>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Table
                    columns={columns}
                    dataList={documentList}
                    dataIds={documentIds}
                    rowSize="fit"
                    onDelete={onDelete}
                    bottomContent={productEditAccess && (
                        <Button
                            variant="success"
                            onClick={() => {
                                dispatch(addModal({
                                    key: "drive",
                                    content: <Drive onSelectFile={onAdd} />,
                                }))
                            }}
                        >
                            {lang.add}
                        </Button>
                    )}
                />
            </PageContent>
        </Container>
    )
}
export default Documents
